import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = () => {
  const session = useSelector((state) => state.session);
  return session !== null ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
